import React, { ComponentClass, FunctionComponent } from "react";

interface HighlightProps {
  elementProps: any;
  element: string | FunctionComponent<any> | ComponentClass<any>;
  phrase: string;
  children: string;
}

export const Highlight: React.FC<HighlightProps> = ({
  element,
  elementProps = {},
  children,
  phrase,
}) => {
  if (typeof children !== "string") {
    console.warn(
      `Highlight cannot be used with content that is not of type string.`,
    );
    return <>{children}</>;
  }

  const content = children as string;
  const matcher = new RegExp(phrase, "i");
  const result = matcher.exec(content);
  const idx = result?.index;
  const foundMatch = !!idx;

  if (!foundMatch) {
    console.warn(
      `The phrase "${phrase}" was not provided and could not be highlighted.`,
    );
    return <>{content}</>;
  }

  const [matchedText] = result!; // to honour the original formatting in the result
  return (
    <>
      {content.slice(0, idx!)}
      {React.createElement(element, elementProps, matchedText)}
      {content.slice(idx! + matchedText.length)}
    </>
  );
};
